/**
 * 도메인별 경로 rewrite 설정
 *
 * 특정 도메인으로 접속 시 해당 prefix로 경로를 rewrite합니다.
 * - key: 도메인 (hostname)
 * - value.prefix: rewrite할 경로 prefix
 * - value.routes: rewrite 대상 경로 목록 (이 목록에 있는 경로만 rewrite, 나머지는 통과)
 *
 * 예시:
 *   ktechpioneers.com/       → /ktechpioneers/       (rewrite)
 *   ktechpioneers.com/list   → /ktechpioneers/list   (rewrite)
 *   ktechpioneers.com/login  → /login                (통과)
 *   ktechpioneers.com/01     → /01                   (통과, 기존 iframe 방식)
 */
export interface DomainRouteConfig {
  prefix: string
  routes: string[]
  hideCompanyNameInPolicy?: boolean
  gtmId?: string
}

export const domainRewriteMap: Record<string, DomainRouteConfig> = {
  'ktechpioneers.com': {
    prefix: '/ktechpioneers',
    routes: ['/', '/list'],
    hideCompanyNameInPolicy: true,
    gtmId: 'GTM-WD97SW96',
  },
}
